var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShieldGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icShieldGreen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.18972783,0 C9.02400945,0 8.85853194,0.0569690064 8.72388576,0.171391862 L8.2922472,0.537690452 C8.28622545,0.5427813 7.52459535,1.17913722 6.28965621,1.85161392 C5.14432062,2.47536393 3.34068804,3.26420286 1.25186569,3.48020024 L0.677391368,3.53959346 C0.32042242,3.5764415 0.0443857024,3.87146822 0.029210909,4.23219112 L0.00464219598,4.81303257 C0,4.92212216 -0.097486572,7.52330275 0.889356736,10.6452043 C1.47418845,12.4956061 2.32084558,14.1564345 3.40572287,15.5813869 C4.77410383,17.3786984 6.51824159,18.7946813 8.58996219,19.790548 L8.87780152,19.9289706 C8.97631724,19.9762427 9.08278167,20 9.18924609,20 C9.29571051,20 9.40217494,19.9762427 9.50069066,19.9289706 L9.78852999,19.790548 C11.8600097,18.7949237 13.6043883,17.3786984 14.9727693,15.5813869 C16.0576466,14.1564345 16.9043037,12.4956061 17.4891354,10.6452043 C18.4745335,7.52718149 18.3783784,4.922607 18.37385,4.81327499 L18.3492813,4.23219112 C18.3341065,3.87146822 18.0580698,3.57668392 17.7011008,3.53959346 L17.1266265,3.48020024 C15.038045,3.26420286 13.2344124,2.47536393 12.0890768,1.85161392 C10.8546194,1.17937964 10.0929893,0.543023721 10.0852815,0.536720767 L9.65629251,0.171876705 C9.52140546,0.057453849 9.35544621,0 9.18972783,0 L9.18972783,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.845597266,0.172609584 C1.28759383,0.172609584 1.66158301,0.476037953 1.66158301,1.0138541 C1.66158301,2.65494381 1.50292197,5.01324679 1.50292197,6.65433649 C1.50292197,7.08187949 1.11759251,7.26110985 0.845597266,7.26110985 C0.482982615,7.26110985 0.176966548,7.0818378 0.176966548,6.65433649 C0.176966548,5.01324679 0.0183397683,2.65494381 0.0183397683,1.0138541 C0.0183397683,0.476037953 0.380954419,0.172609584 0.845597266,0.172609584 Z M0.845334861,9.83874631 C0.372794067,9.83874631 0.0183397683,9.38682501 0.0183397683,8.87213264 C0.0183397683,8.34487847 0.372761598,7.90551896 0.845334861,7.90551896 C1.2856673,7.90551896 1.66158301,8.34487847 1.66158301,8.87213264 C1.66158301,9.38682501 1.2856673,9.83874631 0.845334861,9.83874631 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Active-now----Dating-safety",
    transform: "translate(-342.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(10.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(331.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icShieldGreen",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.648649, 4.864865)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShieldGreen);
export default __webpack_public_path__ + "static/media/icShieldGreen.5734e13876c3dbee7eaa0c5f6d632213.svg";
export { ForwardRef as ReactComponent };